<template>
	<div id="information-detail">
		<div class="content-container">
			<div class="title">{{ item.name }}</div>
			<van-row class="remark" type="flex" justify="space-between">
				<div>{{ item.publish_time }}</div>
			</van-row>
			<div class="content" v-html="item.content"></div>
		</div>
		<div class="divider"></div>
		<div class="comment-container">
			<div class="allTitle">全部评论</div>
			<commonComment :type="2" :is_open="is_open" :likes_count="likes_count" :comment_count="comment_count" :di_likes="di_likes"></commonComment>
		</div>
	</div>
</template>

<script>
import CommonComment from '@/components/CommonComment.vue'
import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
	data() {
		return {
			activeName: 'content',
			item: {},
			comment_count: 0,
			likes_count: 0,
			di_likes: false, //true表示已經点过赞
			is_open: true,
		}
	},
	watch: {
		communityId() {
			this.getData()
		},
	},
	computed: {
		...mapGetters(['token', 'userId', 'companyId']),
	},
	methods: {
		read() {
			this.vaxios.post(
				`${this.vaxios.host}/open/api/v1/discusses/read`,
				{ id: this.$route.query.id, type: 2 },
				(res) => {
					return res
				},
				function(err) {
					console.log(err)
				},
				{
					headers: {
						Authorization: 'Bearer ' + this.token,
						'Content-Type': 'application/json',
					},
				}
			)
		},
		getData() {
			this.item = {
				id: '',
				name: '',
				publish_time: '',
				content: '',
				read_count: '',
			}
			this.vaxios.get(
				`${this.vaxios.host}/open/api/v1/news/${this.$route.query.id}/detail`,
				{ userId: this.userId },
				(res) => {
					this.item.id = res.data.id
					this.item.name = res.data.name
					this.item.publish_time = moment(parseInt(res.data.publish_time)).format('YYYY-MM-DD HH:mm:ss')
					this.item.content = res.data.content
					this.item.read_count = res.data.read_count
					this.comment_count = res.data.comment_count
					this.likes_count = res.data.likes_count
					this.di_likes = res.data.di_likes
					this.item.read_count = this.getSimpleText(res.data.content)
					this.is_open = res.data.is_open === 1 //0 关 ， 1 开
				},
				function(err) {
					console.log(err)
				}
			)
		},
		// 时间戳
		formatDate(value) {
			var date = new Date(parseInt(value))
			var Y = date.getFullYear() + '-'
			var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
			var D = date.getDate() + ' '
			return Y + M + D
		},

		// 富文本的字数
		//html剔除富文本标签，留下纯文本
		getSimpleText(html) {
			var re1 = new RegExp('<.+?>|&nbsp;', 'g') //匹配html标签的正则表达式，"g"是搜索匹配多个符合的内容
			var msg = html.replace(re1, '') //执行替换成空字符
			return msg.length
		},
	},
	components: {
		commonComment: CommonComment,
	},
	created() {
		this.communityId = this.$route.query.communityId
		this.getData()
	},
	mounted() {
		this.read()
	},
}
</script>

<style scoped>
#information-detail {
	margin-bottom: 100px;
}
.content-container {
	font-size: 1.375rem;
	color: #272727;
	font-weight: bold;
	min-height: 4.4375rem;
	padding: 0.625rem 1rem 0 1rem;
}
.title {
	font-size: 1.375rem;
	color: #272727;
	font-weight: bold;
	min-height: 2.4375rem;
}
.content-container {
	font-size: 0.75rem;
	color: #5c5c5c;
	padding: 0 1rem 0 1rem;
}
.remark {
	font-size: 0.75rem;
	color: #5c5c5c;
}
.content-container {
	padding: 0 1.21875rem 0 1rem;
	margin-top: 8px;
	margin-top: 10px;
}
.content {
	margin-top: 1.9375rem;
}
.divider {
	width: 100%;
	height: 0.75rem;
	background-color: #f5f5f5;
}
.title {
	margin-top: 1rem;
	font-size: 1.25rem;
	color: #272727;
	font-weight: bold;
}
.allTitle {
	padding: 0.625rem 1rem 1rem 1rem;
}
.comment-container {
	margin-top: 1rem;
	margin-bottom: 1.59375rem;
	font-size: 1.25rem;
	color: #272727;
	font-weight: bold;
}
.content {
	margin: 0;
}
.content /deep/ table {
	width: 100% !important;
}
</style>
